import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SettingsEdit } from "../settings/settingsEdit";
import { getApiCall, postApiCall } from "./tokenService";

export const getSettingsEdit = (): Promise<SettingsEdit> => {
    return getApiCall("api/app/settings", SettingsEdit);
};

export const saveSettings = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/app/settingssave", ApiSuccess, JSON.stringify(obj));
};